__turbopack_context__.v({
  "bestChoiceLabel": "TariffsTableMobile-module-scss-module__tE8qbG__bestChoiceLabel",
  "boldValue": "TariffsTableMobile-module-scss-module__tE8qbG__boldValue",
  "container": "TariffsTableMobile-module-scss-module__tE8qbG__container",
  "hint": "TariffsTableMobile-module-scss-module__tE8qbG__hint",
  "icon": "TariffsTableMobile-module-scss-module__tE8qbG__icon",
  "price": "TariffsTableMobile-module-scss-module__tE8qbG__price",
  "showMoreButton": "TariffsTableMobile-module-scss-module__tE8qbG__showMoreButton",
  "tariff": "TariffsTableMobile-module-scss-module__tE8qbG__tariff",
  "tariffDate": "TariffsTableMobile-module-scss-module__tE8qbG__tariffDate",
  "tariffHeader": "TariffsTableMobile-module-scss-module__tE8qbG__tariffHeader",
  "tariffInfo": "TariffsTableMobile-module-scss-module__tE8qbG__tariffInfo",
  "tariffName": "TariffsTableMobile-module-scss-module__tE8qbG__tariffName",
  "tariffParameters": "TariffsTableMobile-module-scss-module__tE8qbG__tariffParameters",
  "tariffPrompt": "TariffsTableMobile-module-scss-module__tE8qbG__tariffPrompt",
  "tariffSection": "TariffsTableMobile-module-scss-module__tE8qbG__tariffSection",
  "tariffSettingDescription": "TariffsTableMobile-module-scss-module__tE8qbG__tariffSettingDescription",
  "tariffSettingLabel": "TariffsTableMobile-module-scss-module__tE8qbG__tariffSettingLabel",
  "tariffSettingPoint": "TariffsTableMobile-module-scss-module__tE8qbG__tariffSettingPoint",
  "tariffSettingTitle": "TariffsTableMobile-module-scss-module__tE8qbG__tariffSettingTitle",
  "tariffSettingValue": "TariffsTableMobile-module-scss-module__tE8qbG__tariffSettingValue",
});
